/* eslint-disable react-hooks/exhaustive-deps */
import {
    IonContent,
    IonPage,
    useIonViewDidEnter,
    IonLoading,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
} from '@ionic/react'
import React, { useState, useEffect, useRef } from 'react'
import {
    getKnowledgeTagList,
    getKnowledgeList,
    updateKnowledge,
    PaginationModel,
} from '../../service/api/knowledge'
import { useSelector } from 'react-redux'
import { ReduxStore } from '../../redux/reducers'
import { UserModel } from '../../model/user.model'
import { TagModel } from '../../model/tag.model'
import TagTree from './components/TagTree'
import { TagNameFlag } from '../../conf'
import 'rc-drawer/assets/index.css'
import Drawer from 'rc-drawer'
import './index.css'
import KnowledgeCell from './components/KnowledgeCell'
import { ArrowDownIcon, SearchIcon } from '../../conf/images'
import { KnowledgeModel } from '../../model/knowledge.model'
import { LoadingProps } from '../../model/toast.model'
import { useHistory } from 'react-router'
import EmptyMsg from '../../components/EmptyMsg'
import { getBotLockedKnowledges } from '../../service/api/bot'
import { KnowledgeDetailPage } from '../../conf/routePath'
import SearchBar from '../../components/SearchBar'
import Header from '../../components/Header'
import SearchedCell from './components/SearchedCell'
interface FilterTagModel extends TagModel {
    realTagName?: string
}
const BotKnowledges: React.FC = () => {
    const history = useHistory<{ rootTagId: number; botId: string }>()
    const state = history.location.state
    /** bot root 分类ID */
    const rootTagId = state ? state.rootTagId : null
    console.log('root tag id', rootTagId)
    /** 机器人ID */
    const botId = state ? state.botId : null
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )
    /** 分类抽屉组件显示/隐藏  */
    const [tagDrawerShow, setTagDrawerShow] = useState(false)
    /** 父分类列表 */
    const [parentTags, setParentTags] = useState<FilterTagModel[]>([])
    /** 子分类列表 */
    const [childTags, setChildTags] = useState<FilterTagModel[]>([])
    /** 选中的父分类 */
    const [
        selectedParentTag,
        setSelectedParentTag,
    ] = useState<FilterTagModel | null>()
    /** 选中的子分类 */
    const [
        selectedChildTag,
        setSelectedChildTag,
    ] = useState<FilterTagModel | null>()
    /** 过滤的分类 */
    const [filterTag, setFilterTag] = useState<FilterTagModel | null>(null)
    /** 分类下的知识点列表 */
    const [tagKnowledges, setTagKnowledges] = useState<KnowledgeModel[]>([])
    /** loading props */
    const [loadingOptions, setLoadingOptions] = useState<LoadingProps>({
        isOpen: false,
        message: '加载中...',
    })
    /** 加载更多组件 */
    const ionInfiniteScroll = useRef<any>(null)
    const ionInfiniteScrollForSearch = useRef<any>(null)
    /** 分页 */
    const [pagination, setPagination] = useState<PaginationModel>({
        page: 1,
        page_size: 20,
    })
    /** 没有更多知识点 */
    const [noMore, setNoMore] = useState(false)
    /** 机器人下无分类 */
    const [tagEmpty, setTagEmpty] = useState(false)
    /** 分类下无知识点 */
    const [knowledgesEmpty, setKnowledgesEmpty] = useState(false)
    const [botLockedKnowledgesMap, setBotLockedKnowledgesMap] = useState<{
        [key: string]: string
    }>({})
    const [searchbarShow, setSearchBarShow] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [searchedKnowledges, setSearchedKnowledges] = useState<
        KnowledgeModel[]
    >([])
    const [searchPagination, setSearchPagination] = useState<PaginationModel>({
        page: 1,
        page_size: 20,
    })
    const [searchNoMore, setSearchNoMore] = useState(false)
    /** 页面进入事件 */
    useIonViewDidEnter(() => {
        setPagination({
            ...pagination,
            page: 1,
        })
    })
    useEffect(() => {
        queryTagList()
    }, [])
    // 处理搜索值变化
    useEffect(() => {
        if (searchValue) {
            if (searchPagination.page === 1) {
                searchKnowledges()
            } else {
                setSearchPagination({
                    ...searchPagination,
                    page: 1,
                })
            }
        } else {
            setSearchedKnowledges([])
        }
    }, [searchValue])
    // 处理搜索分页变化
    useEffect(() => {
        searchKnowledges()
    }, [searchPagination])
    /** 分页改变事件 */
    useEffect(() => {
        queryTagKnowledges()
    }, [pagination])
    /** 筛选分类改变事件 */
    useEffect(() => {
        setTagDrawerShow(false)
        setPagination({
            ...pagination,
            page: 1,
        })
        // queryTagKnowledges();
    }, [filterTag])
    /** 父分类变化，加载子分类 */
    useEffect(() => {
        if (selectedParentTag) {
            setChildTags([])
            if (selectedParentTag.realTagName === '全部') return
            ;(async () => {
                try {
                    let childTags = await getChildTagList(selectedParentTag)
                    if (childTags) {
                        setChildTags(childTags)
                    }
                } catch (error) {}
            })()
        }
    }, [selectedParentTag])
    // 查询锁定的知识点标题列表
    const queryLockedKnowledges = async () => {
        if (!botId) return
        try {
            let res = await getBotLockedKnowledges(botId)
            setBotLockedKnowledgesMap(res.data)
        } catch (error) {}
    }
    const searchKnowledges = async () => {
        if (searchPagination.page === 1) {
            setSearchNoMore(false)
        }
        try {
            await queryLockedKnowledges()
            const tagTotalId = parentTags[0].ktag_id || 0
            let res = await getKnowledgeList({
                appHash: userInfo.app_hash,
                // 如果是搜索状态，则将tagId设置为0，表示全局搜索
                tagId: tagTotalId,
                pagination: searchPagination,
                queryContent: {
                    // 只有在搜索状态下，才传入搜索关键字
                    keywords: searchValue,
                    querytype: 'all',
                },
            })
            const knowledgeList = res.data.getKnowledgeList.rows
            setKnowledgesEmpty(
                searchPagination.page === 1 && knowledgeList.length === 0
            )
            if (knowledgeList.length < searchPagination.page_size) {
                setSearchNoMore(true)
            }
            if (searchPagination.page === 1) {
                setSearchedKnowledges([...knowledgeList])
            } else {
                setSearchedKnowledges([...searchedKnowledges, ...knowledgeList])
            }
        } catch (error) {}
        // 上拉加载完毕
        if (
            ionInfiniteScrollForSearch !== null &&
            ionInfiniteScrollForSearch.current !== null
        ) {
            ionInfiniteScrollForSearch.current.complete()
        }
    }
    /** 获取分类下知识列表 */
    const queryTagKnowledges = async () => {
        if (!filterTag) return
        if (pagination.page === 1 && !searchbarShow) {
            setLoadingOptions({
                ...loadingOptions,
                isOpen: true,
            })
            setNoMore(false)
        }
        try {
            await queryLockedKnowledges()
            let res = await getKnowledgeList({
                appHash: userInfo.app_hash,
                // 如果是搜索状态，则将tagId设置为0，表示全局搜索
                tagId: filterTag.ktag_id,
                pagination: pagination,
                queryContent: {
                    // 只有在搜索状态下，才传入搜索关键字
                    keywords: '',
                    querytype: 'all',
                },
            })
            const knowledgeList = res.data.getKnowledgeList.rows
            setKnowledgesEmpty(
                pagination.page === 1 && knowledgeList.length === 0
            )
            if (knowledgeList.length < pagination.page_size) {
                setNoMore(true)
            }
            if (pagination.page === 1) {
                setTagKnowledges([...knowledgeList])
            } else {
                setTagKnowledges([...tagKnowledges, ...knowledgeList])
            }
        } catch (error) {}
        // 上拉加载完毕
        if (ionInfiniteScroll !== null && ionInfiniteScroll.current !== null) {
            ionInfiniteScroll.current.complete()
        }
        setLoadingOptions({
            ...loadingOptions,
            isOpen: false,
        })
    }
    /** 获取机器人 父分类列表 */
    const queryTagList = async () => {
        try {
            let botRootTag = await getBotRootTag()
            if (botRootTag) {
                let tags = await getChildTagList(botRootTag)
                if (tags) {
                    setParentTags(tags)
                }
            }
        } catch (error) {}
    }
    /** 获取机器人 子分类列表 */
    const getChildTagList = async (parentTag?: TagModel) => {
        try {
            if (!parentTag) return null
            let parentTagsRes = await getKnowledgeTagList({
                appHash: userInfo.app_hash,
                tagParent: parentTag.ktag_id,
            })
            if (parentTagsRes.data.getTagList.length > 0) {
                let tags: FilterTagModel[] = parentTagsRes.data.getTagList.map(
                    (item) => ({
                        ...item,
                        ktag_name: parseTagName(item.ktag_name),
                        realTagName: parseTagName(item.ktag_name),
                    })
                )
                tags = [
                    {
                        ktag_id: parentTag.ktag_id,
                        ktag_name: '全部',
                        realTagName: parentTag.ktag_name || '全部',
                        count: parentTag.count,
                    },
                    ...tags,
                ]
                return tags
            }
            return null
        } catch (error) {
            return null
        }
    }
    /** 获取机器人 根分类 id */
    const getBotRootTag = async () => {
        if (!rootTagId) return
        try {
            let res = await getKnowledgeTagList({
                appHash: userInfo.app_hash,
                tagParent: userInfo.root_tag_id,
            })
            if (res.data.getTagList.length > 0) {
                const botsRootTags: FilterTagModel[] = res.data.getTagList.filter(
                    (item) => item.ktag_name.indexOf(TagNameFlag) > 0
                )
                const botRootTag = botsRootTags.filter(
                    (item) =>
                        item.ktag_name.split(TagNameFlag)[0] ===
                        String(rootTagId)
                )[0]
                if (!botRootTag) {
                    setTagEmpty(true)
                    return
                }
                botRootTag.ktag_name =
                    parseTagName(botRootTag.ktag_name) || '全部'
                botRootTag.realTagName = '全部'
                console.log('bot root tag', botRootTag)
                setSelectedParentTag(botRootTag)
                setFilterTag(botRootTag)
                return botRootTag
            }
            setTagEmpty(true)
            return null
        } catch (error) {
            return null
        }
    }
    const parseTagName = (tagName: string) => {
        return tagName.split(TagNameFlag)[1]
    }
    /** 修改知识点状态 */
    const handleKnowledgeStatusChange = async (knowledge: KnowledgeModel) => {
        try {
            setLoadingOptions({
                ...loadingOptions,
                isOpen: true,
            })
            let res = await updateKnowledge({
                appHash: userInfo.app_hash,
                kId: knowledge.k_id,
                kUp: {
                    k_id: knowledge.k_id,
                    k_title: knowledge.k_title,
                    status: Math.abs((knowledge.status as number) - 1),
                    q_count: knowledge.q_count,
                },
            })
            if (res.data.updateKnowledge.successfully) {
                // setTagKnowledges([])
                setPagination({
                    ...pagination,
                    page: 1,
                })
                // await queryTagKnowledges()
            }
        } catch (error) {}
        setLoadingOptions({
            ...loadingOptions,
            isOpen: false,
        })
    }
    // 比对知识点标题是否处于锁定状态
    const checkKnowledgeLock = (k_title: string) => {
        k_title = k_title.replace(/<em>/gi, '')
        k_title = k_title.replace(/<\/em>/gi, '')
        console.log(k_title)
        for (const key in botLockedKnowledgesMap) {
            if (botLockedKnowledgesMap.hasOwnProperty(key)) {
                if (botLockedKnowledgesMap[key] === k_title) return true
            }
        }
        return false
    }
    const handleGotoDetail = (knowledge: KnowledgeModel) => {
        let locked = checkKnowledgeLock(knowledge.k_title)
        console.log('knowledge_locked', locked)
        history.push(KnowledgeDetailPage, {
            knowledge: {
                ...knowledge,
                locked: locked,
                isBotKnowledge: true,
            },
        } as any)
    }
    return (
        <IonPage>
            <IonContent className='bot-knowledges-content'>
                {filterTag && !tagDrawerShow && !searchbarShow && (
                    <Header className='bot-knowledges-header'>
                        <div
                            className='filter-tag'
                            onClick={() => setTagDrawerShow(true)}
                        >
                            <p className='ellipsis'>{filterTag.realTagName}</p>
                            <img className='icon' src={ArrowDownIcon} alt='' />
                        </div>
                        <div
                            className='search-button'
                            onClick={() => setSearchBarShow(true)}
                        >
                            <img
                                className='icon'
                                src={SearchIcon}
                                alt='search'
                            />
                        </div>
                    </Header>
                )}
                {searchbarShow && (
                    <SearchBar
                        onChange={setSearchValue}
                        placeholder='请输入问题'
                        onCancel={() => {
                            setSearchValue('')
                            setSearchBarShow(false)
                        }}
                    />
                )}
                {searchbarShow && (
                    <div className='searched-knowledges'>
                        {searchedKnowledges.map((item) => (
                            <SearchedCell
                                key={item.k_id}
                                dataSource={item}
                                onClick={() => handleGotoDetail(item)}
                            />
                        ))}
                        {!searchNoMore && searchedKnowledges.length > 0 && (
                            <IonInfiniteScroll
                                threshold='60px'
                                ref={ionInfiniteScrollForSearch}
                                onIonInfinite={(e) =>
                                    setSearchPagination({
                                        ...searchPagination,
                                        page: searchPagination.page + 1,
                                    })
                                }
                            >
                                <IonInfiniteScrollContent
                                    loadingSpinner='bubbles'
                                    loadingText='加载更多'
                                ></IonInfiniteScrollContent>
                            </IonInfiniteScroll>
                        )}
                    </div>
                )}
                {!searchbarShow && (
                    <div className='filtered-knowledges'>
                        {tagKnowledges.map((item) => (
                            <KnowledgeCell
                                key={item.k_id}
                                onClick={() => {
                                    handleGotoDetail(item)
                                }}
                                dataSource={item}
                                onStatusChange={() =>
                                    handleKnowledgeStatusChange(item)
                                }
                            />
                        ))}
                        {!noMore && tagKnowledges.length > 0 && (
                            <IonInfiniteScroll
                                threshold='60px'
                                ref={ionInfiniteScroll}
                                onIonInfinite={(e) =>
                                    setPagination({
                                        ...pagination,
                                        page: pagination.page + 1,
                                    })
                                }
                            >
                                <IonInfiniteScrollContent
                                    loadingSpinner='bubbles'
                                    loadingText='加载更多'
                                ></IonInfiniteScrollContent>
                            </IonInfiniteScroll>
                        )}
                    </div>
                )}

                <Drawer
                    onChange={(open) => setTagDrawerShow(!!open)}
                    open={tagDrawerShow}
                    handler={false}
                    width='100%'
                    placement='top'
                    onClose={() => setTagDrawerShow(false)}
                >
                    <TagTree
                        parentTags={parentTags}
                        childTags={childTags}
                        selectedChildTag={selectedChildTag}
                        selectedParentTag={selectedParentTag}
                        onSelectParentTag={setSelectedParentTag}
                        onSelectChildTag={setSelectedChildTag}
                        onFilterChange={setFilterTag}
                    />
                </Drawer>
                <IonLoading {...loadingOptions} />
                <EmptyMsg show={tagEmpty}>该机器人暂无知识！</EmptyMsg>
                <EmptyMsg show={knowledgesEmpty}>
                    {!searchbarShow
                        ? tagKnowledges.length === 0
                            ? '该分类下暂无知识！'
                            : ''
                        : '未搜索到相关问题，请重新输入'}
                </EmptyMsg>
            </IonContent>
        </IonPage>
    )
}

export default BotKnowledges
